module.exports = __webpack_public_path__ + "static/media/EduardoTardelli.2b28c311.png";